import {Injectable, ErrorHandler} from '@angular/core';
import {isUndefined} from 'util';

export class MyErrorHandler implements ErrorHandler {

  errorMessage: string;
  errorDetail: any;
  isSssionExpired: boolean;

  handleError(error) {
    console.log(error);
    let _msg = '';
    if (error._body){
      if (error._body.detail !== null) {
        /* Error message modification */
        if (JSON.parse(error._body).message === 'Validation Failed'){
          const jsonBody = JSON.parse(error._body).detail;
          const errorDetails = JSON.parse(error._body).detail;
          for (const key of Object.keys(errorDetails)) {
            const errorInfo = errorDetails[key];
            _msg += errorInfo + '<br />';
          }
        }else{
          _msg = JSON.stringify(JSON.parse(error._body).detail);
        }

        if (_msg === undefined) {
          _msg = '';
        }
      }
      if (JSON.parse(error._body).message === 'Validation Failed'){
        this.errorMessage = JSON.parse(error._body).message + ' <br />' + _msg;
      }else{
        this.errorMessage = JSON.parse(error._body).message + ' ' + _msg;
      }
    }
    if (error.status === 401) {
      this.isSssionExpired = true;
    } else {
      this.isSssionExpired = false;
    }
    return this;
  }
}
